import React from 'react';
import Avatar from '@material-ui/core/Avatar';
import Replay from '@material-ui/icons/Reply';
import AvatarCounter from './components/AvatarCounter';
import AvatarUser from '../AvatarUser';

function AvatarList(props) {
  const extraUsers =
    props.allUsers && props.allUsers.length > 4
      ? props.allUsers.length - 4
      : false;

  return (
    <div className="subHeaderAvatars mb-10">
      {props.allUsers
        .filter((user, index) => index < 4)
        .map(user => (
          <AvatarUser key={user.userId} user={user} />
        ))}
      {extraUsers && <AvatarCounter number={extraUsers} />}
      <Avatar
        className="mui-avatar share-user"
        onClick={() => props.handleOpenShareDialog(props.projectId)}
      >
        {' '}
        <Replay />{' '}
      </Avatar>
    </div>
  );
}

export default AvatarList;
